import { useEffect, useState, type SVGProps } from 'react'

export interface PieChartProps extends SVGProps<SVGSVGElement> {
    data?: number[]
    colors?: string[]
}

const defaultColors = [
    'red',
    'yellow',
    'cyan',
    'blue',
    'green',
    'black',
    'white',
    'gray',
    'purple',
]

const CIRCLE_LENGTH = 371.9451599121094

export function PieChart({
    data = [10, 20, 40, 50],
    colors = defaultColors,
    className = '',
    ...props
}: PieChartProps) {
    const [hasMounted, setHasMounted] = useState(false)

    useEffect(() => {
        setHasMounted(true)
    }, [])

    const dataTotal = data.reduce((acc, val) => acc + val, 0) || 1

    let startingPoint = 0
    const dataObjects = data.map((item, index) => {
        const relativeSize = (item / dataTotal) * CIRCLE_LENGTH
        const dataObject = {
            relativeSize: hasMounted ? relativeSize : 0,
            offset: -startingPoint,
            color: colors[index % colors.length],
        }
        startingPoint += relativeSize
        return dataObject
    })

    return (
        <svg
            role="img"
            aria-label={props['aria-label'] ?? 'Pie chart'}
            viewBox="0 0 120 120"
            className={`w-32 h-32 ${className}`.trim()}
            {...props}
        >
            {dataObjects.map((item, index) => (
                <circle
                    key={index}
                    cx="50%"
                    cy="50%"
                    r="25%"
                    fill="none"
                    stroke={item.color}
                    strokeWidth="32"
                    style={{
                        strokeDasharray: `${item.relativeSize} ${CIRCLE_LENGTH}`,
                        strokeDashoffset: item.offset,
                        transition:
                            'stroke-dasharray 0.3s ease-in-out, stroke-dashoffset 0.3s ease-in-out',
                    }}
                />
            ))}
        </svg>
    )
}
